var version_fs2pro='v1.0.1-Golive web Fs2pro lần 1';export default version_fs2pro;